import { Calendar } from 'iconoir-react';

import i18n from '~/common/helpers/i18n';
import type { TimeOption } from '~/components/ContentHeader';

export const AGENT_TIME_OPTIONS: TimeOption[] = [
  { label: i18n.t('scenes.time_ranges.5_minutes'), value: '5m' },
  { label: i18n.t('scenes.time_ranges.15_minutes'), value: '15m' },
  { label: i18n.t('scenes.time_ranges.1_hour'), value: '1h' },
  {
    label: (
      <>
        <span>{i18n.t('label.custom')}</span>
        <Calendar className='icon-smallest' />
      </>
    ),
    value: 'specific'
  }
];

export const INTERVAL_TO_API_MAP: Record<string, string> = {
  '5m': '5 Minutes',
  '15m': '15 Minutes',
  '1h': '1 Hour',
  'custom-range': 'specific'
};

export const URL_TO_TIME_MAP: Record<string, string> = {
  '5 Minutes': '5m',
  '15 Minutes': '15m',
  '1 Hour': '1h',
  specific: 'custom-range'
};

export const DEFAULT_AGENT_TIME_RANGE = '5 Minutes';

export const TABLE_COLUMNS = [
  {
    key: 'timestamp',
    label: i18n.t('scenes.monitor.agentLogs.table.timestamp'),
    sortable: true,
    testId: 'monitor-agent-logs-table-column-timestamp'
  },
  {
    key: 'agentName',
    label: i18n.t('scenes.monitor.agentLogs.table.agent_name'),
    testId: 'monitor-agent-logs-table-column-agent-name'
  },
  {
    key: 'agentExecutionKey',
    label: i18n.t('scenes.monitor.agentLogs.table.agent_execution_key'),
    testId: 'monitor-agent-logs-table-column-agent-execution-key'
  },
  {
    key: 'pipelineName',
    label: i18n.t('scenes.monitor.agentLogs.table.pipeline_name'),
    testId: 'monitor-agent-logs-table-column-pipeline-name'
  },
  {
    key: 'contentPreview',
    label: i18n.t('scenes.monitor.agentLogs.table.content_preview'),
    testId: 'monitor-agent-logs-table-column-content-preview'
  }
];
